/*
     Title:Assign Input Table API
     Description:Assign Input Table API
     Author: Iqbal Hossain
     Date: 26-January-2022
     Modified: 26-January-2022
*/

export const ASSIGN_INPUT_TABLE_API = {
  root: '/api/assign-input-table',
  fetch_all: 'api/assign-input-table/fetch-all',
  fetch_by_query: `/api/assign-input-table/fetch-by-query`,
  fetch_by_id: `/api/assign-input-table/fetch-by-id`,
  get_by_range: `/api/assign-input-table/get-range`
};
